import { SerializrAttributeContext } from '../schema/general/RootSchema';
export class DeserializeAttributeContext extends SerializrAttributeContext {
    constructor(init) {
        super(init);
    }
    get oldValue() {
        if (this.oldValue_isOverwritten) {
            return this.oldValue_overwrite;
        }
        if (this.propDef && this.propDef.shouldDisgardOldValue && this.propDef.shouldDisgardOldValue(this)) {
            return undefined;
        }
        const oldValue = this.objectContext.target[this.propName];
        return oldValue;
    }
    set oldValue(v) {
        this.oldValue_overwrite = v;
        this.oldValue_isOverwritten = true;
    }
    get json() {
        if (typeof this.json_overwrite !== 'undefined') {
            return this.json_overwrite;
        }
        return this.objectContext.ser[this.attrName];
    }
}
